// extracted by mini-css-extract-plugin
module.exports = {"exportBox":"studio_exportBox__Lj_5c","copy_alter_box":"studio_copy_alter_box__Ff5Fb","copy_text":"studio_copy_text__UGLEF"};